<template>
  <div class="flex items-center justify-around py-40">
    <div class="flex items-center gap-12">
      <RevButtonIcon
        :alternative-text="i18n(translations.previous)"
        data-qa="previous-listing-page-button"
        :disabled="!hasPreviousPage"
        :icon="IconChevronLeft"
        variant="secondary"
        @click="onPreviousPage"
      />
      <span
        :class="
          hasPreviousPage
            ? 'text-static-default-hi'
            : 'text-static-default-hi-disabled'
        "
      >
        {{ i18n(translations.previous) }}
      </span>
    </div>

    <div class="flex items-center gap-12">
      <span
        :class="
          hasNextPage
            ? 'text-static-default-hi'
            : 'text-static-default-hi-disabled'
        "
        >{{ i18n(translations.next) }}</span
      >
      <RevButtonIcon
        :alternative-text="i18n(translations.next)"
        data-qa="next-listing-page-button"
        :disabled="!hasNextPage"
        :icon="IconChevronRight"
        variant="secondary"
        @click="onNextPage"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButtonIcon } from '@ds/components/ButtonIcon'
import { IconChevronLeft } from '@ds/icons/IconChevronLeft'
import { IconChevronRight } from '@ds/icons/IconChevronRight'

import translations from './Pagination.translations'

defineProps<{
  hasPreviousPage: boolean
  hasNextPage: boolean
  onPreviousPage: () => void
  onNextPage: () => void
}>()

const i18n = useI18n()
</script>
